<div class="p-4">
    <div [formGroup]="form" class="mt-4 flex flex-col">
        <div class="flex justify-between mx-2 items-center">
            <h4>Importar Planilha de Passageiros</h4>
            <button mat-icon-button matSuffix (click)="closeModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-divider></mat-divider>
        <div class="flex justify-center gap-5 items-center w-12/12">

            <div class="mt-message-input w-8/12 p-2">
                <input hidden type="file" (change)="onFileSelected($event)" #fileInput [accept]="getAllowedTypes()" />
                <!--        accept=".xlsx,.application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"-->
                <mat-form-field class="input-tg input-btn-icon w-full" appearance="outline">
                    <mat-label>Arquivo</mat-label>
                    <input matInput formControlName="file" readonly />
                    <button mat-icon-button matSuffix (click)="fileInput.click()">
                        <mat-icon>upload</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="flex justify-center items-center gap-4 p-2">
                <button mat-flat-button class="btn-tg" (click)="cancel()">
                    Cancel
                </button>

                <button mat-flat-button class="btn-tg" [disabled]="form.invalid || loading" (click)="createFile()">
                    @if (loading) {
                    <mat-spinner diameter="22" class="loading-spinner" selected-track-color="red"></mat-spinner>
                    } @else {
                    Importar
                    }
                </button>

            </div>
        </div>
    </div>
</div>